import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";

const ViewSettingsDialog = ({ open, onClose, settingsType, settings }) => {
	const formatKey = (key) => {
		return key
			.replace(/([A-Z])/g, " $1")
			.replace(/_/g, " ")
			.replace(/^./, (str) => str.toUpperCase())
			.trim();
	};

	const renderObjectTable = (obj) => (
		<Table size="small">
			<TableBody>
				{Object.entries(obj).map(([key, val]) => (
					<TableRow key={key}>
						{settingsType === 7 ? (
							<>
								<TableCell
									sx={{
										fontWeight: "bold",
										display: "flex",
										justifyContent: "center",
									}}
								>
									{formatKey(key)}
								</TableCell>
								{typeof val === "object" ? (Array.isArray(val) ? renderArrayTable(val) : renderObjectTable(val)) : String(val)}
							</>
						) : (
							<TableCell sx={{ fontWeight: "bold" }}>
								{formatKey(key)}:
								{typeof val === "object" ? (Array.isArray(val) ? renderArrayTable(val) : renderObjectTable(val)) : String(val)}
							</TableCell>
						)}
					</TableRow>
				))}
			</TableBody>
		</Table>
	);

	const renderArrayTable = (arr) => {
		if (arr.length === 0 || typeof arr[0] !== "object") {
			return <Typography>{JSON.stringify(arr)}</Typography>;
		}

		const headers = Object.keys(arr[0]);
		return (
			<Table size="small" sx={{ mb: 2 }}>
				<TableHead>
					<TableRow>
						{headers.map((key) => (
							<TableCell key={key}>{formatKey(key)}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{arr.map((item, idx) => (
						<TableRow key={idx}>
							{headers.map((key) => (
								<TableCell key={key}>
									{typeof item[key] === "object"
										? Array.isArray(item[key])
											? renderArrayTable(item[key])
											: renderObjectTable(item[key])
										: String(item[key])}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		);
	};

	const parsedSettings = (() => {
		try {
			return JSON.parse(settings || "{}");
		} catch (err) {
			return null;
		}
	})();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>View Settings</DialogTitle>
			<DialogContent dividers>
				{parsedSettings ? (
					Array.isArray(parsedSettings) ? (
						renderArrayTable(parsedSettings)
					) : (
						renderObjectTable(parsedSettings)
					)
				) : (
					<Typography color="error">Invalid JSON format</Typography>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ViewSettingsDialog;
